import { Link } from '@melio/penny';
import { DeliveryMethod, formatAddress } from '@melio/platform-api';
import { useMelioIntl } from '@melio/platform-i18n';

export const useDeliveryMethodBannerText = ({
  deliveryMethod,
  onChange,
}: {
  deliveryMethod?: DeliveryMethod;
  onChange: VoidFunction;
}) => {
  const { formatMessage } = useMelioIntl();

  const linkProps = {
    onClick: (e: React.MouseEvent) => {
      e.preventDefault();
      onChange();
    },
    href: '#',
    ['data-testid']: 'delivery-method-banner-change-link',
  };

  if (!deliveryMethod) {
    return formatMessage('activities.paymentFlow.form.content.deliveryMethod.missing.label', {
      link: (
        <Link {...linkProps} label={formatMessage('activities.paymentFlow.form.content.deliveryMethod.missing.link')} />
      ),
    });
  }

  switch (deliveryMethod.type) {
    case 'bank-account':
      return deliveryMethod.isManaged
        ? formatMessage('activities.paymentFlow.form.content.deliveryMethod.bank-account.managed.label')
        : formatMessage('activities.paymentFlow.form.content.deliveryMethod.bank-account.label', {
            account: deliveryMethod.details.accountNumber.slice(-4),
            link: (
              <Link {...linkProps} label={formatMessage('activities.paymentFlow.form.content.deliveryMethod.change')} />
            ),
          });
    case 'paper-check':
      return formatMessage('activities.paymentFlow.form.content.deliveryMethod.paper-check.label', {
        address: formatAddress(deliveryMethod.details.address),
        link: (
          <Link {...linkProps} label={formatMessage('activities.paymentFlow.form.content.deliveryMethod.change')} />
        ),
      });
    default:
      return null;
  }
};
